import { Helmet } from "react-helmet-async";

const BASE = process.env.REACT_APP_BACKEND_URL || "";

export default function SEO({ title, description, path = "/", image = "/middleman-logo.jpg" }) {
  const fullTitle = title ? `${title} | Middle Man` : "Middle Man — Verified Local Help for Everyday Tasks";
  const url = `${BASE}${path}`;
  const img = image.startsWith("http") ? image : `${BASE}${image}`;
  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={url} />
      <meta property="og:type" content="website" />
      <meta property="og:site_name" content="Middle Man" />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={img} />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
    </Helmet>
  );
}
